import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../auth.service';
import { TokenStorageService } from '../token-storage.service';

/**
 * `/profiles` (C29/V219): only a picker session may stand here. A tenant
 * session — member or superuser — belongs on the dashboard.
 */
@Injectable({ providedIn: 'root' })
export class PickerSessionGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private tokenStorage: TokenStorageService,
    private router: Router
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    await this.authService.rescueMobileSession();
    if (!this.authService.isAuthenticated()) {
      return this.router.parseUrl('/login');
    }
    return this.tokenStorage.isPickerSession() ? true : this.router.parseUrl('/dashboard');
  }
}
